export const colorTypes = [
  {
    type: 'HEX',
    value: '#FFFFFF00',
  },
  {
    type: 'HSB',
    value: 'HSBA(0, 0%, 100%, 0)',
  },
  {
    type: 'RGB',
    value: 'RGBA(255, 255, 255, 0)',
  },
  {
    type: 'HSL',
    value: 'HSLA(0, 0%, 100%, 0)',
  },
]
